























import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import MainButton from '../common/MainButton.vue';

@Component({
  components: { MainButton },
})
export default class QuestionBankNotFound extends Vue {
  @Prop({ required: true })
  title: string;

  @Prop({ required: true })
  description: string;

  @Prop({ required: true })
  mainButtonLabel: string;

  @Prop({ required: true })
  isSubjective: boolean;

  @Prop({ required: true })
  onMainButtonClick: () => void;

  @Inject('addOrEditQuestion')
  addOrEditQuestion!: (isSubjective: boolean) => Promise<void>;
}
